export const AUTH = 'auth'

export const MARKET_STATS_LIST = 'marketStatsList'
export const MARKET_STATS_LIST_ALL = 'marketStatsListAll'
